import { render, staticRenderFns } from "./ScoreAnnouncement.vue?vue&type=template&id=da22d522&scoped=true&"
import script from "./ScoreAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ScoreAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "@/tbs/stylesheet/dynamic.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ScoreAnnouncement.vue?vue&type=style&index=1&id=da22d522&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da22d522",
  null
  
)

export default component.exports